import useStyles from './styles'
import {Paper , Typography , useMediaQuery} from '@material-ui/core' 
import Rating from '@material-ui/lab/Rating';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import GoogleMapReact from 'google-map-react';
import mapStyles from './mapStyles'


function Map({coordinates,setCoordinates,setBoundaries , places , setChildClicked,coords,weatherData}) {
    const classes = useStyles() ;       //hook for material ui custom styles file
    const isDesktop = useMediaQuery('(min-width:600px)') ;  //material ui media query hook  
  
    
    //showing the map using google-map-react liberary & passing the key and other props
    return (
        <div className={classes.mapContainer}>
            <GoogleMapReact  bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY }}  
                             defaultCenter={coords} center={coordinates}  defaultZoom={14} 
                             margin={[50,50,50,50]} options={{ disableDefaultUI: true, zoomControl: true, styles: mapStyles }} 
                             onChange={(e)=>{
                                setCoordinates({lat : e.center.lat , lng : e.center.lng}) ;
                                setBoundaries({ne:e.marginBounds.ne ,sw:e.marginBounds.sw }); }} 
                             onChildClick={(child) => setChildClicked(child)}  >

                  {/* showing cards and icons on the map locations */}                
                        {places?.map((place,i)=>(
                            <div className={classes.markerContainer} lat={Number(place.latitude)} lng={Number(place.longitude)} key={i}>
                                    { !isDesktop? <LocationOnOutlinedIcon color='primary' fontSize='large'/> :
                                      <Paper elevation={3} className={classes.paper}> 
                                              <Typography className={classes.Typography} gutterBottom variant="subtitle2">
                                                {place.name}  
                                              </Typography>  
                                              <img className={classes.pointer} src={place.photo ? place.photo.images.large.url : 'https://www.foodserviceandhospitality.com/wp-content/uploads/2016/09/Restaurant-Placeholder-001.jpg'} alt={place.name} />
                                              <Rating size='small' value={Number(place.rating)} readOnly/>  
                                      </Paper>
                                    }
                            </div>
                        ))}   

                {/* showing weather on the map locations */} 
                        {weatherData?.list?.map((data,i)=>(
                            <div key={i} lat={data.coord.lat} lng={data.coord.lon}>
                                <img src={`https://openweathermap.org/img/w/${data.weather[0].icon}.png`} height="80px" alt='' />
                            </div>
                        ))}  

            </GoogleMapReact>
        </div>
    )
}

export default Map
